import { render, staticRenderFns } from "./ValidateSuccess.vue?vue&type=template&id=a625478a&scoped=true"
import script from "./ValidateSuccess.vue?vue&type=script&lang=js"
export * from "./ValidateSuccess.vue?vue&type=script&lang=js"
import style0 from "./ValidateSuccess.vue?vue&type=style&index=0&id=a625478a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a625478a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a625478a')) {
      api.createRecord('a625478a', component.options)
    } else {
      api.reload('a625478a', component.options)
    }
    module.hot.accept("./ValidateSuccess.vue?vue&type=template&id=a625478a&scoped=true", function () {
      api.rerender('a625478a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Register/ValidateSuccess.vue"
export default component.exports